import { ConfigMurucaResourceLayout } from '@net7/boilerplate-muruca';

export default {
  maxHeight: 100, // Threshold where the "read-more" button appears
  title: 'resource#title_graffito',
  type: 'graffito',
  tabs: 'graffito',
  sections: {
    top: [
      {
        id: 'header',
        type: 'title',
        grid: null,
      },
      {
        id: 'editor_metadata',
        type: 'metadata',
      },
      { // da togliere quando ci sarà parallel
        id: 'image-viewer-iiif',
        type: 'viewer-iiif',
        title: 'resource#image-viewer-iiif',
        options: {
          libOptions: {
            window: {
              sideBarOpenByDefault: false,
              allowClose: false,
              allowMaximize: true,
              defaultSideBarPanel: 'info',
              views: [
                { key: 'single' },
                { key: 'gallery' },
              ],
              workspaceControlPanel: {
                enabled: false,
              },
            },
            id: 'mirador-container',
          },
        }
      },
      { // da togliere quando ci sarà parallel
        id: 'text-viewer-graffito_text',
        type: 'text-viewer',
        options: {
          searchId: 'xml_text',
        },
      },
      // {
      //   id: 'parallel-text-viewer',
      //   type: 'parallel-text-viewer',
      //   options: {
      //     searchId: 'xml_text',
      //     grid: {
      //       panels: [0],
      //     },
      //     panels:[
      //       {
      //         id: "facsimile",
      //         title: "Facsimile",
      //         enabled: true,
      //         type: 'tify',
      //         manifest: '', // link manifest generale
      //       },
      //     ]
      //   },
      // },
      {
        id: 'tab-bar',
        type: 'tabs',
      },
    ],
    content: [
      {
        id: 'metadata-graffito_description',
        type: 'metadata',
        // title: 'resource#metadata_graffito_description',
      },
    ],
  },
} as ConfigMurucaResourceLayout;